import { White } from '@constants/color';
import { css } from '@emotion/react';

export const icon = css({
  fill: White.White10Alpha50
});
export const focused = css({
  fill: White.White10
});
